// extracted by mini-css-extract-plugin
export default {"totals":"u8M13aUO--styles_totals__fzkBZ","shimmer":"u8M13aUO--styles_shimmer__-U6ya"};